// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6ba59d78","453":"bcfc7ccd","455":"11e7c30e","977":"7f289780"}[chunkId] + ".chunk.js";
};